module.exports = __webpack_public_path__ + "img/blaise.cbf37bc2.jpg";